{
  "dashboard": {
    "place": {
      "inShift": "En ce moment : {{clinic}} · jusqu’à {{end}}",
      "between": "Prochaine plage horaire : {{clinic}} · {{start}}",
      "beforeFirst": "Aujourd’hui : {{clinic}} à partir de {{start}}",
      "done": "Plage horaire du jour terminée · {{clinic}}",
      "overlap": "Présence prévue dans {{count}} cabinets à la fois",
      "noShiftToday": "Aucun horaire de présence enregistré pour aujourd’hui",
      "noShiftDay": "Aucun horaire de présence enregistré pour ce jour",
      "noShiftHint": "Vos horaires de présence sont saisis par la clinique",
      "otherDay": "{{weekday}} : {{clinic}} {{hours}}",
      "more": "(autres cabinets : {{count}})",
      "aria": "Lieu de travail selon vos horaires de présence"
    },
    "stats": {
      "total": "rendez-vous",
      "waiting": "en attente",
      "completed": "vu(s)",
      "cancelled": "annulé(s)",
      "aria": "Rendez-vous : {{total}}, en attente : {{waiting}}, vus : {{completed}}, annulés : {{cancelled}}",
      "share": "Votre part : {{amount}}",
      "shareNoFigure": "Votre part"
    },
    "week": {
      "title": "Choisir un jour",
      "thisWeek": "Cette semaine",
      "nextWeek": "Semaine prochaine",
      "prevWeek": "Semaine dernière",
      "range": "du {{from}} au {{to}}",
      "fullCalendar": "Agenda complet",
      "backToWeek": "Retour à la semaine",
      "countAria": "{{count}} rendez-vous"
    },
    "clinic": {
      "auto": "Automatique — selon mes horaires de présence",
      "autoSub": "Le cabinet indiqué par vos horaires de présence pour ce jour",
      "autoBadge": "Auto"
    },
    "book": {
      "open": "Nouveau rendez-vous",
      "title": "Planifier un rendez-vous",
      "clinic": "Clinique",
      "patient": "Patient",
      "searchLabel": "Rechercher un patient",
      "searchPlaceholder": "Nom, téléphone ou numéro national",
      "searchHint": "Saisissez au moins deux caractères.",
      "noMatch": "Aucun patient de votre liste ne correspond à cette recherche.",
      "truncated": "Seuls les {{count}} premiers résultats sont affichés ; affinez la recherche.",
      "newPatient": "Nouveau patient",
      "pickExisting": "Choisir parmi les patients",
      "change": "Changer",
      "name": "Nom complet",
      "phone": "N° de portable",
      "nationalId": "Numéro national (facultatif)",
      "when": "Date et heure",
      "duration": "Durée",
      "minutes": "{{count}} min",
      "note": "Note (facultatif)",
      "submit": "Planifier le rendez-vous",
      "submitRequest": "Soumettre à l’approbation de la clinique",
      "readOnlyTitle": "Lecture seule — l’abonnement de la clinique a pris fin",
      "readOnly": "L’abonnement de cette clinique a pris fin et son espace est en lecture seule ; aucun rendez-vous ne peut y être pris ni déplacé tant que la clinique ne l’a pas renouvelé. Vos autres cliniques ne sont pas concernées.",
      "readOnlyOption": "{{name}} (lecture seule)",
      "needsApprovalTitle": "Approbation de la clinique requise",
      "needsApproval": "Les rendez-vous que vous planifiez dans cette clinique ne deviennent définitifs qu’après confirmation par l’accueil ; d’ici là, ils restent « en attente de confirmation de la clinique ».",
      "booked": "Rendez-vous planifié.",
      "requested": "Rendez-vous envoyé à la clinique pour approbation.",
      "loadFailed": "Impossible de charger vos cliniques.",
      "noClinic": "Vous ne pouvez planifier de rendez-vous dans aucune clinique pour le moment.",
      "searchFailed": "La recherche de patient a échoué.",
      "modeFirstDay": "Premier créneau de ce jour",
      "modeFirstToday": "Premier créneau aujourd’hui",
      "modeManual": "Choisir l’heure",
      "showTimeOptions": "Changer le jour ou le mode de choix de l’heure",
      "hideTimeOptions": "Masquer les options d’horaire",
      "noneLeftToday": "Il ne reste aucun créneau libre aujourd’hui.",
      "finding": "Recherche du prochain créneau libre…",
      "bookThisOne": "Choisir ce créneau",
      "firstFree": "Premier créneau libre",
      "exactAtBooking": "L’heure exacte est fixée lors de l’enregistrement du rendez-vous.",
      "firstSlotFailed": "Impossible de trouver le prochain créneau libre. Vous pouvez choisir l’heure vous-même.",
      "lessOptions": "Masquer les options supplémentaires",
      "typeInPerson": "En présentiel",
      "typeOnline": "Téléconsultation",
      "submitFirst": "Planifier au premier créneau libre",
      "walkIn": "Sans horaire, maintenant",
      "walkInOff": "Le patient est déjà là ; ajoutez-le sans horaire à la file d’attente du jour.",
      "walkInOn": "Rendez-vous enregistré sans horaire ; le patient rejoint dès maintenant la file d’attente du jour.",
      "walkInOnShort": "Sans horaire ; ajouté à la file du jour.",
      "walkInLead": "Plus aucun créneau libre aujourd’hui ; ajoutez dès maintenant le patient à la file d’attente du jour, sans horaire.",
      "walkInLeadShort": "Sans horaire, file du jour.",
      "walkInNoGrant": "Dans cette clinique, vos rendez-vous attendent la confirmation de l’accueil ; un patient déjà présent est ajouté par l’accueil de la clinique.",
      "walkInNoGrantShort": "Dans cette clinique, seul l’accueil peut ajouter un patient sans horaire.",
      "alreadyOpen": {
        "scheduled": "Ce patient a déjà un autre rendez-vous aujourd’hui et n’est pas encore arrivé.",
        "arrived": "Ce patient est déjà dans la file d’attente du jour — faut-il un deuxième rendez-vous ?",
        "in_visit": "Ce patient est en consultation en ce moment — faut-il un deuxième rendez-vous ?"
      },
      "submitWalkIn": "Ajouter à la file d’attente",
      "walkInBooked": "Patient ajouté à la file d’attente du jour.",
      "mode": "Mode de choix de l’heure",
      "day": "Jour",
      "visitType": "Type de consultation",
      "moreOptions": "Plus d’options (type de consultation, durée, note)",
      "noneThisDay": "Vous n’avez aucun créneau libre ce jour-là.",
      "nextIs": "Votre prochain créneau libre :",
      "noneIn30Days": "Aucun créneau libre n’a été trouvé non plus dans les 30 prochains jours.",
      "slotAt": "{{date}} à {{time}}",
      "errors": {
        "clinic": "Choisissez une clinique.",
        "patient": "Choisissez un patient.",
        "name": "Saisissez le nom du patient.",
        "phone": "Ce numéro de portable n’est pas valide.",
        "nationalId": "Ce numéro national n’est pas valide.",
        "when": "Saisissez la date et l’heure.",
        "past": "Cette heure est déjà passée.",
        "noSlot": "Aucun créneau libre ce jour-là ; choisissez un autre jour ou saisissez l’heure vous-même.",
        "phoneShared": "Ce numéro a d’autres dossiers ; choisissez-en un ou appuyez sur « Nouveau patient sur ce numéro »."
      },
      "searchPickClinic": "Choisissez d’abord une clinique pour rechercher ses patients.",
      "phoneCandidates": {
        "title": "Ce numéro figure déjà dans des dossiers : {{count}}",
        "hint": "La personne en face de vous est-elle l’une d’elles ? Choisissez-la. S’il s’agit d’une autre personne avec le même numéro (un membre de la famille, par exemple), appuyez sur « Nouveau patient sur ce numéro ».",
        "choose": "Choisir",
        "sharedNote": "Un nouveau patient sera enregistré avec un numéro qui figure déjà dans d’autres dossiers.",
        "showAgain": "Afficher les dossiers",
        "inClinic": "Dans la liste de cette clinique",
        "conflictOnSubmit": "Ce numéro vient d’être enregistré dans un autre dossier ; vérifiez la liste.",
        "lookupFailed": "Impossible de vérifier les dossiers de ce numéro. Veuillez réessayer.",
        "checking": "Vérification des dossiers de ce numéro…",
        "checkFailed": "Impossible de vérifier les dossiers de ce numéro ; ils seront revérifiés lors de la prise de rendez-vous."
      }
    },
    "phones": {
      "more": "Autres numéros : {{count}}",
      "otherLine": "{{relation}} : {{phone}}"
    },
    "withdraw": {
      "action": "Retirer la demande",
      "title": "Retirer la demande de rendez-vous",
      "message": "Retirer la demande de rendez-vous de {{name}} ? Elle sera supprimée de la liste de la clinique.",
      "confirm": "Retirer la demande",
      "keep": "Retour",
      "failed": "Impossible de retirer la demande."
    },
    "reschedule": {
      "current": "Horaire actuel : {{when}}",
      "newTime": "Nouvel horaire",
      "hint": "Le rendez-vous est déplacé, et non annulé puis planifié à nouveau : sa facture et son paiement restent inchangés.",
      "moved": "Le rendez-vous a été déplacé au {{when}}."
    },
    "edit": {
      "untimedCurrent": "Hors tour — pas encore d'heure",
      "setTimeHint": "Fixez l'heure de ce rendez-vous ; aucun message n'est envoyé au patient.",
      "action": "Modifier le rendez-vous",
      "title": "Modifier le rendez-vous",
      "submit": "Enregistrer les modifications",
      "type": "Type de consultation",
      "inPerson": "En cabinet",
      "online": "En ligne",
      "typeHint": "Seul le type de consultation change ; son tarif reste celui de la réservation.",
      "typeLocked": {
        "over": "Cette consultation est terminée ; son type ne peut plus changer.",
        "notConfigured": "Les consultations en ligne ne sont pas activées sur ce système."
      },
      "timeLocked": {
        "status": "Seul un rendez-vous qui attend encore son patient peut être déplacé ; ce patient est arrivé ou la consultation a commencé.",
        "grant": "Dans cette clinique, vos rendez-vous sont confirmés par l’accueil ; laissez l’accueil de la clinique déplacer celui-ci.",
        "untimed": "Ce rendez-vous n’a pas d’horaire fixe : il n’y a donc pas d’horaire à modifier."
      },
      "note": "Note du rendez-vous"
    },
    "rowOps": {
      "more": "Autres actions pour {{name}}",
      "next": "Passer en suivant",
      "backToRoom": "Retour au cabinet",
      "note": "Note du rendez-vous",
      "nextAppt": "Prochain rendez-vous",
      "noShow": "Absence",
      "cancel": "Annuler le rendez-vous",
      "cancelled": "Le rendez-vous de {{name}} a été annulé.",
      "cancelTitle": "Annuler le rendez-vous",
      "cancelMessage": "Le rendez-vous de {{name}} à {{time}} sera annulé. Cette action est définitive.",
      "cancelConfirm": "Oui, annuler",
      "noShowTitle": "Enregistrer une absence",
      "noShowMessage": "Le rendez-vous de {{name}} à {{time}} sera enregistré comme une absence.",
      "noShowConfirm": "Enregistrer l’absence",
      "noteTitle": "Note du rendez-vous",
      "noteLabel": "Note pour le rendez-vous de {{name}}",
      "noteHint": "L’accueil de la clinique voit aussi cette note. Laissez-la vide pour l’effacer.",
      "noteSave": "Enregistrer la note",
      "errors": {
        "hasPayment": "Un paiement a été encaissé pour ce rendez-vous ; son annulation revient à l’accueil.",
        "needsGrant": "Dans cette clinique, les annulations et les absences sont gérées par l’accueil.",
        "paymentCheck": "Impossible de vérifier le paiement de ce rendez-vous ; veuillez réessayer.",
        "readOnly": "L’abonnement de cette clinique a pris fin et son espace est en lecture seule ; ce changement attendra son renouvellement.",
        "gone": "Ce rendez-vous n’existe plus ; la liste a été actualisée.",
        "next": "Impossible de faire passer ce patient en suivant.",
        "cancel": "Impossible d’annuler le rendez-vous.",
        "noShow": "Impossible d’enregistrer l’absence.",
        "note": "Impossible d’enregistrer la note."
      }
    }
  },
  "nav": {
    "mobile": {
      "more": "Plus",
      "moreTitle": "Plus",
      "account": "Compte",
      "sections": "Sections",
      "balance": "Solde {{coin}}"
    }
  }
}
